import { render, staticRenderFns } from "./SwitchToHris.vue?vue&type=template&id=4947c86e&scoped=true&"
import script from "./SwitchToHris.vue?vue&type=script&lang=js&"
export * from "./SwitchToHris.vue?vue&type=script&lang=js&"
import style0 from "./SwitchToHris.vue?vue&type=style&index=0&id=4947c86e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4947c86e",
  null
  
)

export default component.exports